import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onboardings-dashboard',
  templateUrl: './onboardings-dashboard.component.html',
  styleUrls: ['./onboardings-dashboard.component.scss']
})
export class OnboardingsDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
